import { render } from "./ItemGrid.vue?vue&type=template&id=37548823"
import script from "./ItemGrid.vue?vue&type=script&lang=js"
export * from "./ItemGrid.vue?vue&type=script&lang=js"

import "./ItemGrid.vue?vue&type=style&index=0&id=37548823&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__